import {
  type UserData,
  type CardData,
  type UserCard,
  type PlanData,
  type Me,
  TariffStatusEnum,
} from '@libs/types';

export const qrResponse = {
  qr_path: 'card_images/qrcode/1833de61-1f3b-4a81-9301-a8b6f811ee63.png',
  qr_url: 'https://turbopush.io/card/972',
  qr_download_link: 'http://127.0.0.1:8000/account/qr_code/972/download',
  qr_name: 0,
};

export const companySearchResults = {
  status: 'success',
  results: [
    {
      url: 'https://www.facebook.com/photo.php?fbid=2331636520199994&id=573990992631231&set=a.577318915631772',
      title: 'US Department of Health and Human Se',
      facebook_logo:
        'https://scontent.xx.fbcdn.net/v/t39.30808-1/283087002_371889894982971_6593308547516136321_n.jpg?stp=c0.0.270.270a_dst-jpg_s200x200&_nc_cat=100&ccb=1-7&_nc_sid=f4b9fd&_nc_ohc=mH6dJOUP8DAQ7kNvgGMlESP&_nc_zt=24&_nc_ht=scontent.xx&_nc_gid=Ae0cjRg7ZTVaYmKzcGyVUFa&oh=00_AYChg1cEbQjdCXGq9Yl7GUJZi7eY1WQwy41WzrzmQO2oTg&oe=6730DF97',
      facebook_desc:
        '500 Horizon Dr, Ste 530, Robbinsville, NJ, United States, New Jersey',
      facebook_info: [
        'https://scontent.xx.fbcdn.net/v/t39.30808-6/288007217_388537893318171_5709104271374438710_n.jpg?stp=dst-jpg_s960x960&_nc_cat=108&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=qGlG9BT7OlMQ7kNvgHrAsaA&_nc_zt=23&_nc_ht=scontent.xx&_nc_gid=Ae0cjRg7ZTVaYmKzcGyVUFa&oh=00_AYABJbTHrxV_AanaMn_NqhO5H3Md1SodYDUzsfoHGL2CMg&oe=6730FF72',
        'https://scontent.xx.fbcdn.net/v/t39.30808-1/283087002_371889894982971_6593308547516136321_n.jpg?stp=c0.0.270.270a_dst-jpg_s200x200&_nc_cat=100&ccb=1-7&_nc_sid=f4b9fd&_nc_ohc=mH6dJOUP8DAQ7kNvgGMlESP&_nc_zt=24&_nc_ht=scontent.xx&_nc_gid=Ae0cjRg7ZTVaYmKzcGyVUFa&oh=00_AYChg1cEbQjdCXGq9Yl7GUJZi7eY1WQwy41WzrzmQO2oTg&oe=6730DF97',
        'Autism New Jersey',
        '500 Horizon Dr, Ste 530, Robbinsville, NJ, United States, New Jersey',
      ],
    },
    {
      url: 'https://m.facebook.com/story.php/?story_fbid=884398240399588&id=100064882594461',
      title: 'AAP Pediatrics - Autism spectrum disorder (ASD) is...',
      facebook_logo:
        'https://scontent.xx.fbcdn.net/v/t39.30808-1/292482235_410325771140864_9052610529665989577_n.png?stp=dst-png_s200x200&_nc_cat=1&ccb=1-7&_nc_sid=f4b9fd&_nc_ohc=4jHhy-eWKlUQ7kNvgEQs4-R&_nc_zt=24&_nc_ht=scontent.xx&_nc_gid=At29gPSpKoXvTCYMfsSKhpv&oh=00_AYD0s0tsjIcadOfk1oGEorlGJ7fY6qjZiYsA9kTtd9UQ2Q&oe=6730CF1B',
      facebook_desc: 'AUTISM SPEAKS, INC.es responsable de esta página',
      facebook_info: [
        'https://scontent.xx.fbcdn.net/v/t39.30808-6/435678568_815048810668556_4609120345644443082_n.png?_nc_cat=105&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=h6rJmrF6HxcQ7kNvgFWCF6q&_nc_zt=23&_nc_ht=scontent.xx&_nc_gid=At29gPSpKoXvTCYMfsSKhpv&oh=00_AYDOfsdL7aS0R1gxjTYtMl85o-1jFe-vdVhvYM72CbOSsA&oe=6730E609',
        'https://scontent.xx.fbcdn.net/v/t39.30808-1/292482235_410325771140864_9052610529665989577_n.png?stp=dst-png_s200x200&_nc_cat=1&ccb=1-7&_nc_sid=f4b9fd&_nc_ohc=4jHhy-eWKlUQ7kNvgEQs4-R&_nc_zt=24&_nc_ht=scontent.xx&_nc_gid=At29gPSpKoXvTCYMfsSKhpv&oh=00_AYD0s0tsjIcadOfk1oGEorlGJ7fY6qjZiYsA9kTtd9UQ2Q&oe=6730CF1B',
        'Autism Speaks Cuenta verificada',
        'AUTISM SPEAKS, INC.es responsable de esta página',
      ],
    },
    {
      url: 'https://m.facebook.com/story.php/?story_fbid=884398240399588&id=100064882594461',
      title: 'AAP Pediatrics - Autism spectrum disorder (ASD) is...',
      facebook_logo:
        'https://scontent.xx.fbcdn.net/v/t39.30808-1/292482235_410325771140864_9052610529665989577_n.png?stp=dst-png_s200x200&_nc_cat=1&ccb=1-7&_nc_sid=f4b9fd&_nc_ohc=4jHhy-eWKlUQ7kNvgEQs4-R&_nc_zt=24&_nc_ht=scontent.xx&_nc_gid=At29gPSpKoXvTCYMfsSKhpv&oh=00_AYD0s0tsjIcadOfk1oGEorlGJ7fY6qjZiYsA9kTtd9UQ2Q&oe=6730CF1B',
      facebook_desc: 'AUTISM SPEAKS, INC.es responsable de esta página',
      facebook_info: [
        'https://scontent.xx.fbcdn.net/v/t39.30808-6/435678568_815048810668556_4609120345644443082_n.png?_nc_cat=105&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=h6rJmrF6HxcQ7kNvgFWCF6q&_nc_zt=23&_nc_ht=scontent.xx&_nc_gid=At29gPSpKoXvTCYMfsSKhpv&oh=00_AYDOfsdL7aS0R1gxjTYtMl85o-1jFe-vdVhvYM72CbOSsA&oe=6730E609',
        'https://scontent.xx.fbcdn.net/v/t39.30808-1/292482235_410325771140864_9052610529665989577_n.png?stp=dst-png_s200x200&_nc_cat=1&ccb=1-7&_nc_sid=f4b9fd&_nc_ohc=4jHhy-eWKlUQ7kNvgEQs4-R&_nc_zt=24&_nc_ht=scontent.xx&_nc_gid=At29gPSpKoXvTCYMfsSKhpv&oh=00_AYD0s0tsjIcadOfk1oGEorlGJ7fY6qjZiYsA9kTtd9UQ2Q&oe=6730CF1B',
        'Autism Speaks Cuenta verificada',
        'AUTISM SPEAKS, INC.es responsable de esta página',
      ],
    },
    {
      url: 'https://m.facebook.com/story.php/?story_fbid=884398240399588&id=100064882594461',
      title: 'AAP Pediatrics - Autism spectrum disorder (ASD) is...',
      facebook_logo:
        'https://scontent.xx.fbcdn.net/v/t39.30808-1/292482235_410325771140864_9052610529665989577_n.png?stp=dst-png_s200x200&_nc_cat=1&ccb=1-7&_nc_sid=f4b9fd&_nc_ohc=4jHhy-eWKlUQ7kNvgEQs4-R&_nc_zt=24&_nc_ht=scontent.xx&_nc_gid=At29gPSpKoXvTCYMfsSKhpv&oh=00_AYD0s0tsjIcadOfk1oGEorlGJ7fY6qjZiYsA9kTtd9UQ2Q&oe=6730CF1B',
      facebook_desc: 'AUTISM SPEAKS, INC.es responsable de esta página',
      facebook_info: [
        'https://scontent.xx.fbcdn.net/v/t39.30808-6/435678568_815048810668556_4609120345644443082_n.png?_nc_cat=105&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=h6rJmrF6HxcQ7kNvgFWCF6q&_nc_zt=23&_nc_ht=scontent.xx&_nc_gid=At29gPSpKoXvTCYMfsSKhpv&oh=00_AYDOfsdL7aS0R1gxjTYtMl85o-1jFe-vdVhvYM72CbOSsA&oe=6730E609',
        'https://scontent.xx.fbcdn.net/v/t39.30808-1/292482235_410325771140864_9052610529665989577_n.png?stp=dst-png_s200x200&_nc_cat=1&ccb=1-7&_nc_sid=f4b9fd&_nc_ohc=4jHhy-eWKlUQ7kNvgEQs4-R&_nc_zt=24&_nc_ht=scontent.xx&_nc_gid=At29gPSpKoXvTCYMfsSKhpv&oh=00_AYD0s0tsjIcadOfk1oGEorlGJ7fY6qjZiYsA9kTtd9UQ2Q&oe=6730CF1B',
        'Autism Speaks Cuenta verificada',
        'AUTISM SPEAKS, INC.es responsable de esta página',
      ],
    },
  ],
};

export const stubData = {
  user_info: {
    user_id: 83,
    username: 'nikita luparev',
    // user_logo:
    //   'https://lh3.googleusercontent.com/a/ACg8ocKYG8rHsFOBpWMDGFBWAGLr9CTZIURoYz_FYCiy8ulIhA1BQA=s96-c',
    // user_logo: '',
    user_email: 'n.luparev@bagoodex.com',
    trial_days: null,
  },
  user_tariff_info: {
    user_tariff: {
      id: 256,
      create_timestamp: '2024-08-05T11:15:49.951386+00:00',
      status: 'active',
      // status: 'trial',
      delete: false,
      stripe_subscription_id: null,
      user_id: 83,
      tariff_id: 6,
      subscription_end_time: '2025-08-05T11:15:48.355927+00:00',
      update_timestamp: '2024-08-05T11:15:49.951386+00:00',
      delete_timestamp: null,
    },
    tariff_name: 'Standard',
    trial_days: null,
    sub_active_flag: 1,
    tariff: {
      id: 6,
      api_id: 'price_1PQp2UInY79hOvCTAPH78Dke',
      cards_clients_per_month: 'unlimited',
      available_cards: '6',
      start_date: null,
      name: 'Standard',
      price: 11.7,
      duration_in_months: 12,
      push_notifications: '2000 push per month + additional package',
      analytics: false,
      end_date: null,
    },
  },
} as UserData;

export const stubCardData: CardData = {
  user_card: {
    card_id: 686,
    reward: 5,
    reward_text: 'Enjoy a 5% discount with your card!',
    issued_number: 0,
    company_name: 'Test',
    cover_url:
      'https://turbopush.io/card_images/caver/f55ca120-39ef-4f99-983e-c64b9047ec65.png',
    logo_url:
      'https://turbopush.io/card_images/logo/cbd9ae9f-7fa6-4c50-8440-a4193496d58d.jpeg',
    info: '',
    address: '',
    phone: null,
    start_time: '09:00 AM',
    end_time: '05:00 PM',
    working_days: 'Mon, Tue',
    push_notifications: '0/2000',
    working_days_list: ['Mon', 'Tue'],
  },
  recently_sent_info: [],
  lk: 1,
};

export const stubCardData2: CardData = {
  user_card: {
    card_id: 989,
    reward: 15,
    reward_text: 'Enjoy a 15% discount with your card!',
    issued_number: 0,
    company_name: 'Angel-in-us Coffee Kazakhstan',
    cover_url:
      'https://turbopush.io/card_images/caver/99903549-15ff-404c-9d81-c980f3712cfb.png',
    logo_url:
      'https://turbopush.io/card_images/logo/1cbdcefe-217f-4d71-b94d-17954bcbef57.png',
    info: '',
    address: '',
    phone: null,
    start_time: '09:00 AM',
    end_time: '05:00 PM',
    working_days: null,
    push_notifications: '0/500',
    working_days_list: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
    card_color: 'rgb(42, 157, 143)',
    text_color: '#000000',
    is_custom_color: true,
  },
  recently_sent_info: [
    {
      card_id: 429,
      text: '🏃 Start your day with a boost: Get a free extra shot of espresso before 9 AM every Monday!',
      date: '17-02-2025',
      time: '06:35 PM',
    },
    {
      card_id: 428,
      text: '🥤🧊 Cool down with our iced drinks: 10% all day',
      date: '17-02-2025',
      time: '06:34 PM',
    },
  ],
  lk: 1,
};

export const stubTemplates = [
  {
    template_id: 29,
    text: '🥤🧊 Cool down with our iced drinks: 10% all day',
    tag: 'cafe',
  },
  {
    template_id: 30,
    text: '🥐 Craving something sweet? Enjoy 20% off all pastries this afternoon',
    tag: 'cafe',
  },
  {
    template_id: 31,
    text: '🏃 Start your day with a boost: Get a free extra shot of espresso before 9 AM every Monday!',
    tag: 'cafe',
  },
  {
    template_id: 32,
    text: '☕☕ Double the coffee, double the fun: Buy one, get one half-price all day.',
    tag: 'cafe',
  },
  {
    template_id: 33,
    text: '🌸 Spring flavors are here! Try our new floral-infused teas.',
    tag: 'cafe',
  },
  {
    template_id: 34,
    text: '🍵 Tea time! Buy one, get one free on all teas from 3 PM to 5 PM.',
    tag: 'cafe',
  },
  {
    template_id: 35,
    text: '🥪 Hungry? Buy one sandwich, get a coffee half-price from 12 PM to 2 PM.',
    tag: 'cafe',
  },
  {
    template_id: 36,
    text: '🥞 Join us for Sunday Brunch! Enjoy unlimited mimosas and our brunch buffet.',
    tag: 'restaurant',
  },
  {
    template_id: 37,
    text: '👶 Kids Eat Free all day on Tuesdays! Bring the family for a delicious meal.',
    tag: 'restaurant',
  },
  {
    template_id: 38,
    text: '🍷 Wine Lovers! Join our wine tasting event this weekend. Reserve your glass!',
    tag: 'restaurant',
  },
  {
    template_id: 39,
    text: '💗💗 Date Night Deal: Free dessert with any two main courses every Friday night.',
    tag: 'restaurant',
  },
  {
    template_id: 40,
    text: '💎 VIPs members only: Preview our upcoming menu this Thursday. Limited seats available!',
    tag: 'restaurant',
  },
  {
    template_id: 41,
    text: '🎉🥂 Celebrate with us! Special holiday menu available. Book now!',
    tag: 'restaurant',
  },
  {
    template_id: 42,
    text: '🍽️ Tonight’s Special: Buy one get one free on all main courses! Dine-in only.',
    tag: 'restaurant',
  },
  {
    template_id: 43,
    text: '🍻 Happy Hour 5-7 PM: 20% off drafts and cocktails!',
    tag: 'bar',
  },
  {
    template_id: 44,
    text: '🏈 Watch the big game here Sunday! Special deals on food & drinks',
    tag: 'bar',
  },
  {
    template_id: 45,
    text: '🍹🏖️ New Summer Cocktails now available! Come taste the season.',
    tag: 'bar',
  },
  {
    template_id: 46,
    text: '🍺 New Craft Beer Alert! Taste our latest brew tonight.',
    tag: 'bar',
  },
  {
    template_id: 47,
    text: '📝 Loved your visit? Rate us & get 10% off your next drink!',
    tag: 'bar',
  },
  {
    template_id: 48,
    text: '🍷 Wine Wednesday: Half off on all wine bottles. Perfect for your midweek break!',
    tag: 'bar',
  },
  {
    template_id: 49,
    text: '🏆 Members Only: Exclusive happy hour this Tuesday!',
    tag: 'bar',
  },
  {
    template_id: 50,
    text: '💎 VIP Night this Friday! Exclusive drinks & offers for members.',
    tag: 'club',
  },
  {
    template_id: 51,
    text: '💃💃 Ladies Night Thursday! Free entry for ladies till 10 PM!',
    tag: 'club',
  },
  {
    template_id: 52,
    text: '⚡️ Tonight: $5 shots until midnight! Let’s light up the night!',
    tag: 'club',
  },
  {
    template_id: 53,
    text: '🌙🍸 Official after-party spot post-concert! Keep the night alive.',
    tag: 'club',
  },
  {
    template_id: 54,
    text: '💕 Singles Night tomorrow! Come mingle with singles & enjoy 2-for-1 drinks!',
    tag: 'club',
  },
  {
    template_id: 55,
    text: '🍾 Book a VIP table this weekend and receive a complimentary bottle of champagne.',
    tag: 'club',
  },
  {
    template_id: 56,
    text: '🎉 Keep the party going! Extended hours this Friday with special late-night DJ.',
    tag: 'club',
  },
];

export const userCards: UserCard[] = [
  {
    card_id: 694,
    reward: 5,
    reward_text: 'Enjoy a 5% discount with your card!',
    issued_number: 0,
    company_name: 'New Test Title',
    cover_url:
      'https://turbopush.io/card_images/caver/b42c8df5-5ae0-4358-baa3-3bb151ba282e.png',
    logo_url:
      'http://127.0.0.1:8000/card_images/logo/45094bc2-a77d-417f-b8a8-1d45b0833de3.png',
    info: 'Sydney, Australia;Portland, OR; Brighton, UK; Hong Kong',
    address: 'Sydney, Australia;Portland, OR; Brighton, UK; Hong Kong',
    phone: null,
    start_time: '12:00 AM',
    end_time: '5:00 AM',
    working_days: 'Mon, Tue, Wed, Thu, Fri',
    push_notifications: '0/2000',
    working_days_list: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
    card_color: 'rgb(250, 250, 250)',
    text_color: '#ffffff',
  },
  {
    card_id: 686,
    reward: 5,
    reward_text: 'Enjoy a 5% discount with your card!',
    issued_number: 0,
    company_name: 'Test',
    cover_url:
      'https://turbopush.io/card_images/caver/f55ca120-39ef-4f99-983e-c64b9047ec65.png',
    logo_url:
      'https://turbopush.io/card_images/logo/afdba106-5b57-4fa0-81c1-feea16fead44.png',
    info: '',
    address: '',
    phone: null,
    start_time: '09:00 AM',
    end_time: '05:00 PM',
    working_days: 'Mon, Tue',
    push_notifications: '0/2000',
    working_days_list: ['Mon', 'Tue'],
    card_color: 'rgb(245, 245, 245)',
    text_color: '#ffffff',
  },
  {
    card_id: 675,
    reward: 5,
    reward_text: '',
    issued_number: 0,
    company_name: '',
    cover_url:
      'https://turbopush.io/card_images/caver/ed552666-3a9d-46eb-a3e6-d8ae8e1ed830.png',
    logo_url:
      'https://turbopush.io/card_images/logo/62985de1-0127-4f67-8bdf-49680558c5b3.png',
    info: '320 Orchard Road, Singapore, Singapore',
    address: '320 Orchard Road, Singapore, Singapore',
    phone: null,
    start_time: '09:00 AM',
    end_time: '05:00 PM',
    working_days: 'Mon, Tue, Wed, Thu, Fri',
    push_notifications: '0/2000',
    working_days_list: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
    card_color: 'rgb(247, 225, 215)',
    text_color: '#ffffff',
  },
];

export const cardReadyResponse: { user_card: UserCard; to_lk: number | null } =
  {
    user_card: {
      card_id: 759,
      reward: 10,
      reward_text: 'Enjoy a 10% discount with your card!',
      issued_number: 0,
      company_name: 'Cafe Stamba',
      cover_url:
        'https://turbopush.io/card_images/caver/72a623ad-e9e6-409a-b2b1-e725394a986a.png',
      logo_url:
        'https://turbopush.io/card_images/logo/5c213683-027f-4332-a481-3fecf00af1f5.png',
      info: '14 M. Kostava St.',
      address: '14 M. Kostava St.',
      phone: null,
      start_time: '09:00 AM',
      end_time: '05:00 PM',
      working_days: null,
      push_notifications: null,
      working_days_list: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      card_color: 'rgb(250, 250, 245)',
      text_color: '#000',
      is_custom_color: true,
    },
    to_lk: 4,
  };

export const planData: PlanData = {
  user_info: {
    user_id: 124,
    username: 'Nikita Luparev',
    user_logo:
      'https://lh3.googleusercontent.com/a/ACg8ocKw1f2jWD75MhSB6IhQ4k0LF4ZcNk0OvKkGcAcJ926f8wrlFg=s96-c',
    user_email: 'n.luparev@turbopush.io',
    trial_days: null,
  },
  user_tariff_info: {
    status: 'active',
    tariff_id: 6,
    create_timestamp: '2024-10-25T08:55:30.857524+00:00',
    update_timestamp: '2024-10-25T08:55:30.857524+00:00',
    subscription_end_time: '2025-10-20T08:55:32.050297+00:00',
    tariff_name: 'Standard',
    trial_days: null,
    sub_active_flag: 1,
    tariff: {
      id: 6,
      name: 'Standard',
      price: 11.7,
      api_id: 'price_1PQp2UInY79hOvCTAPH78Dke',
      duration_in_months: 12,
      cards_clients_per_month: 'unlimited',
      push_notifications: '2000 push per month + additional package',
      available_cards: '5',
      analytics: false,
      start_date: null,
      end_date: null,
    },
  },
  next_debit: '10-20-2025',
};

export const meData: Me = {
  total_cards: 0,
  user: {
    user_id: 254,
    username: 'test_sub@turbopush.io',
    user_logo: '',
    user_email: 'test_sub@turbopush.io',
    trial_days: null,
  },
  user_tariff_info: {
    user_tariff: {
      tariff_id: 6,
      user_id: 254,
      subscription_end_time: '2026-01-17T11:37:17.337358+00:00',
      update_timestamp: '2025-01-22T11:37:14.642096+00:00',
      delete_timestamp: null,
      id: 490,
      create_timestamp: '2025-01-22T11:37:14.642096+00:00',
      status: TariffStatusEnum.ACTIVE,
      // status: TariffStatusEnum.TRIAL,
      delete: false,
      stripe_subscription_id: null,
    },
    tariff_name: 'Standard',
    trial_days: null,
    sub_active_flag: 1,
    tariff: {
      name: 'Standard',
      price: 11.7,
      duration_in_months: 1,
      push_notifications: '2000 push per month + additional package',
      analytics: false,
      end_date: null,
      id: 6,
      api_id: 'price_1PQp2UInY79hOvCTAPH78Dke',
      cards_clients_per_month: 'unlimited',
      available_cards: '5',
      start_date: null,
    },
  },
};
